"use client"

import React from 'react'
import MaxWidthContainer from './max-width-container'
import CustomLabel from '../ui/custom-label'
import { api } from '@/trpc/react'
import { Skeleton } from '../ui/skeleton'
import DestinationCard from './destination-card'
// import { DestinationBg } from '../icons/destination-bg'

export default function CuratedDestination() {
    const { data, isLoading } = api.destination.get_curated_destinations.useQuery()

    if (isLoading) return (
        <section className="py-8 md:py-12 relative overflow-hidden bg-custom-primary-shade">
            <MaxWidthContainer className='space-y-5 relative'>
                <CustomLabel label='Trip Destinations' />
                <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5'>
                    {
                        Array.from({ length: 8 }).map((load, _index) => (
                            <Skeleton key={_index} className='h-64 bg-gray-300 md:h-80 xl:h-96 rounded-lg' />
                        ))
                    }
                </div>
            </MaxWidthContainer>
        </section>
    )

    if (!data) return null
    return (
        <section className="py-8 md:py-12 relative overflow-hidden">
            <MaxWidthContainer className='space-y-5 relative'>
                <CustomLabel label='Trip Destinations' />
                <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5'>
                    {
                        data.map((curdest) => (
                            <DestinationCard
                                key={curdest.slug}
                                href={`/destination/${curdest.slug}`}
                                image={curdest.cover_image_url}
                                price={curdest.trips.length > 0 ? curdest.trips[0]?.trip_batches[0]?.main_price : 0}
                                title={curdest.title}
                                tours={curdest.trips.length}
                                destination={curdest.destination}
                            />
                        ))
                    }
                </div>
            </MaxWidthContainer>
        </section>
    )
}
